import React from "react";
import PropTypes from "prop-types";
import Button from "../../components/ui/Button";

const BookCard = ({ book, onAddToCart }) => {
  return (
    <div className="border rounded-lg shadow hover:shadow-lg transition p-2 flex flex-col">
      <img
        src={book.coverUrl || "/placeholder-book.png"}
        alt={book.title}
        className="w-full h-auto rounded mb-4"
      />

      <h3 className="text-lg font-semibold mb-2">
        {book.title}
      </h3>

      {book.description && (
        <p className="text-gray-600 text-sm mb-2">
          {book.description}
        </p>
      )}

      <p className="text-blue-600 font-bold mb-4">
        R {book.price.toFixed(2)}
      </p>

      <Button
        size="md"
        onClick={() => {
          //console.log("Clicked:", book);
          onAddToCart(book);
        }}
      >
        Add to Cart
      </Button>
    </div>
  );
};

BookCard.propTypes = {
  book: PropTypes.shape({
    title: PropTypes.string.isRequired,
    description: PropTypes.string,
    price: PropTypes.number.isRequired,
    coverUrl: PropTypes.string,
  }).isRequired,
  onAddToCart: PropTypes.func.isRequired,
};

export default BookCard;